export default "__VITE_ASSET__f3641faa__"